import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ReusableService } from '@services/reusable.service';
import { NgxMasonryComponent, NgxMasonryModule } from 'ngx-masonry';
import { EditableCardComponent } from '@components/cards/editable-card/editable-card.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-info-tiles',
  templateUrl: './info-request-tiles.component.html',
  styleUrls: ['./info-request-tiles.component.scss'],
  standalone: true,
  imports: [EditableCardComponent, NgxMasonryModule]
})
export class InfoRequestTilesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() data;
  @Output() reload = new EventEmitter<void>();
  sectionsData: any[] = [];
  rid: string;
  showOnlyGridFlag = true;
  private readonly destroy$ = new Subject<void>();

  constructor(private reusableService: ReusableService) {}
  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;

  ngOnInit(): void {
    this.reusableService.showhpdcTiles.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.showOnlyGridFlag = !data;
    });
  }

  ngOnChanges(): void {
    if (!this.data) return;
    this.rid = this.data.requestRid;
    this.getAllSectionDetails(this.data.request.viewData);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAllSectionDetails(dataset) {
    const { formSchema } = this.data.request;
    const { request_product_rid, caption } = this.data.info;
    const isComplianceQuestionnaire = caption.includes('- Compliance Questionnaire -');
    const excludedKeys = new Set(['class', 'actions', 'object', 'section_actions']);
    const sections = [];

    Object.entries(dataset).forEach(([sectionName, lines]) => {
      if (excludedKeys.has(sectionName)) return;
      const sectionFormSchema = formSchema[sectionName] || [];
      if (
        (!Array.isArray(sectionFormSchema) || sectionFormSchema.length === 0) &&
        (!Array.isArray(lines) || lines.length === 0)
      ) {
        return;
      }

      if (sectionName === 'Shared with' && Array.isArray(lines)) {
        lines.forEach((e) => {
          e.created_by = e.lines?.[0];
        });
      }

      sections.push({
        name: sectionName,
        lines,
        formSchema: sectionFormSchema,
        targetRid: this.rid,
        request_product_rid,
        is_compliance_questionnaire: isComplianceQuestionnaire,
        actions: {
          ...dataset.actions,
          ...dataset.section_actions?.[sectionName]
        }
      });
    });

    this.sectionsData = sections;
    setTimeout(() => this.reloadMasonryLayout(), 50);
  }

  reloadMasonryLayout(): void {
    if (this.masonry) {
      this.masonry.reloadItems();
      this.masonry.layout();
    }
  }

  reloadCardData() {
    this.reload.emit();
  }
}
